import { createClient } from '@exonet/jsonapi-fetcher';
import { bannerErrors } from 'app/client/store/actions/errorActions';

/**
 * Create the fetcher client that normalizes a failed request.
 *
 * A request is only treated as failed when its body contains a JSON:API `errors` key, while a rate
 * limit and a proxy error respond with a plain message or with HTML. Without the key the response
 * is handled as if it succeeded, so the component renders without the data it needs. Only the
 * statuses that show a banner are normalized, the other statuses are handled by the components
 * themselves, like a validation error in a form.
 *
 * The message of the API is kept as the detail of the error, so a component can translate it.
 *
 * @returns {Object} The fetcher client.
 */
export default () => {
  const client = createClient();
  const { send } = client;

  client.send = (...args) =>
    send(...args).catch((error) => {
      const { response } = error;

      if (bannerErrors[response?.status] && !response.data?.errors) {
        response.data = {
          errors: [
            {
              status: String(response.status),
              detail: response.data?.message,
            },
          ],
        };
      }

      return Promise.reject(error);
    });

  return client;
};
